'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdTouchApp = function MdTouchApp(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm31.4 26.5c0.9 0.4 1.5 1.2 1.5 2.3v0.3l-1.3 8.8c-0.1 1.2-1.1 2.1-2.4 2.1h-11.3c-0.7 0-1.3-0.2-1.7-0.7l-8.3-8.3 1.3-1.3c0.3-0.3 0.8-0.6 1.3-0.6 0.2 0 0.3 0.1 0.4 0.1l5.7 1.2v-17.9c0-1.4 1.1-2.5 2.5-2.5s2.5 1.1 2.5 2.5v10h1.4c0.3 0 0.5 0.1 0.8 0.2z m-16.4-7.7c-2-1.4-3.4-3.7-3.4-6.3 0-4.1 3.4-7.5 7.5-7.5s7.5 3.4 7.5 7.5c0 2.6-1.2 4.9-3.2 6.3v-6.3c0-2.3-2-4.1-4.3-4.1s-4.1 1.8-4.1 4.1v6.3z' })
        )
    );
};

exports.default = MdTouchApp;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/touch-app.js
// module id = 2008
// module chunks = 168707334958949